export default __webpack_public_path__ + "static/media/banner7.f783fe2f.png";